import React, {useEffect, useMemo, useRef, useState} from "react";
import { toUrlExcursionVendor } from "../../../helper/vendorMask";
import { useNavigate, useLocation } from "react-router";
import "../../../assets/css/Excursion.css";
import { ChevronDownIcon, ChevronUpIcon, FilterIcon } from "../../../helper/HwIcon";
import HwSelect from "../../../component/HwSelect";
import { getExcurstionList } from "./getExcurstionList";
import { ExcursionSearchLoader } from "./components/ExcursionSearchLoader";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import moment from "moment";
import { AllCategory, ChevronLeftIcon } from "../../../helper/HwIconExcursion";
import {formatePriceFn, formatPrice} from "../../../helper/commonFunction";
import {useSelector} from "react-redux";

const dummyArr = [1, 2, 3];
const ExcursionSkeletonCard = () => {
  return dummyArr.map((d) => {
    return (
      <div className="row">
        {dummyArr.map((d) => {
          return (
            <div className="col-sm-6 col-xl-4">
              <Skeleton
                height="150px"
                width={"100%"}
              />
              <Skeleton height="20px" width={"100%"} count={4} />
            </div>
          );
        })}
      </div>
    );
  });
};

const ExcursionFilterSkeleton = () => (
  <div className="hw-search--flightFilter__bodyBox">
    <div className="hw-search--flightFilter__body pt-null">
      <Skeleton height="44px" width="100%" style={{ marginBottom: 20 }} />
      <Skeleton width="45%" height="16px" style={{ marginBottom: 14 }} />
      <Skeleton height="18px" width="100%" count={5} style={{ marginBottom: 10 }} />
      <Skeleton width="32%" height="16px" style={{ margin: "18px 0 14px" }} />
      <Skeleton height="18px" width="100%" count={5} style={{ marginBottom: 10 }} />
    </div>
  </div>
);

const ExcursionList = () => {
  const {agentActiveCurrency,displayPrice} = useSelector((state) => state.userData);
  const {
    data: list,
    loading: listLoading,
    sortFilter,
    setSortFilter,
    setSelectedCategory,
    selectedCategory,
    showLoadMore,
    setSortBy,
    sortBy,
    setPage,
    page,
    allOptions,
    categoryOptions,
    sortOptions,
  } = getExcurstionList();

  const data = categoryOptions;
  const loading = listLoading;
  const [keyword, setKeyword] = useState("");
  const [search] = useState(null);
  const searching = listLoading;
  const seenLoadingRef = useRef(false);
  const [firstLoadDone, setFirstLoadDone] = useState(false);

  useEffect(() => {
    if (listLoading) {
      seenLoadingRef.current = true;
    } else if (seenLoadingRef.current && !firstLoadDone) {
      setFirstLoadDone(true);
    }
  }, [listLoading, firstLoadDone]);

  const showSearchLoader = listLoading && !firstLoadDone;

  const searchedData = useMemo(() => {
    const term = keyword?.trim()?.toLowerCase();
    if (!term) return allOptions;
    return allOptions?.filter((d) =>
      String(d?.label ?? "").toLowerCase().includes(term)
    );
  }, [allOptions, keyword]);

  const navigate = useNavigate();
  const location = useLocation();

  const loaderParams = new URLSearchParams(location.search);
  const searchCity = (loaderParams.get("city") || "").replace(/-/g, " ").trim();
  const searchDateRaw = loaderParams.get("travel-date");
  const searchDate = searchDateRaw && moment(searchDateRaw, "DD-MM-YYYY", true).isValid()
    ? moment(searchDateRaw, "DD-MM-YYYY").format("DD MMM YYYY")
    : "";

  const goToDetails = (item) => {
    const detailParams = new URLSearchParams({
      vendor: toUrlExcursionVendor(item?.vendor ?? ""),
      "tour-id": item?.tourId ?? "",
      "contract-id": item?.contractId ?? "",
      "country-id": item?.countryId ?? "",
      "city-id": item?.cityId ?? "",
      "travel-date": new URLSearchParams(location.search).get("travel-date") ?? "",
    });
    navigate(`/excursion/details/${item?.excursionId}?${detailParams.toString()}`);
  };

const [isFilterCollapsed, setIsFilterCollapsed] = useState(false);
  const jsToogleFilterClickFn = () => {
        setIsFilterCollapsed(prevState => !prevState);
        document.body.classList.toggle("filter-collapsed");
    }

    useEffect(()=>{
      window.scrollTo(0,0)
    },[sortBy, selectedCategory])

  return (
    <>
    {showSearchLoader ? <ExcursionSearchLoader city={searchCity} date={searchDate} /> : null}

    <div className="hw-page--width">
      <div className="hw-search--flightList hw-search--excursionList">
        {showSearchLoader && (
          <aside className="hw-search--flightFilter">
            <div className="hw-search--flightFilter__top border-none" style={{ zIndex: "10" }}>
              <div className="hw-search--flightFilter__action">
                <div className="js-toggleFilter d-flex align-items-center hw-gapy10"><FilterIcon />Filters</div>
              </div>
            </div>
            <ExcursionFilterSkeleton />
          </aside>
        )}
        {!showSearchLoader && (listLoading || (list?.length ?? 0) > 0) && (
        <aside className="hw-search--flightFilter">
          <div className="hw-search--flightFilter__top border-none" style={{zIndex:"10"}}>
              <div className="hw-search--flightFilter__action">
                  <div onClick={jsToogleFilterClickFn}
                      className="js-toggleFilter d-flex align-items-center hw-gapy10"><FilterIcon />Filters
                  </div>
                  <button onClick={jsToogleFilterClickFn} className="hw-link hw-link--gray700 hw-link--icon"><ChevronLeftIcon />Hide
                  </button>
              </div>
          </div>
          <div className="hw-search--flightFilter__bodyBox">
            <div className="hw-search--flightFilter__body pt-null">
                <div className="hw-search--flightFilter__widget">
                  <div className="hw-excursion--Searchbox">
                    <HwSelect
                      placeholder="Search...."
                      options={searchedData ?? []}
                      onChangeFn={(selected) => {
                        if (selected?.value) {
                          goToDetails(
                            selected?.excursion ??
                              list?.find(
                                (d) =>
                                  String(d?.excursionId) === String(selected?.value)
                              ) ?? { excursionId: selected?.value }
                          );
                        }
                      }}
                      value={search}
                      menuChnageFn={() => null}
                      onInputChangeFn={(d) => {
                        setKeyword(d);
                      }}
                      loading={searching}
                      isMulti={false}
                      type={"excursion"}
                      inputValue={keyword}
                      width="100%"
                    />
                  </div>
                </div>
                 <div className="hw-search--flightFilter__widget">
<div className="hw-book--filter">
            <div className="mb-2 hw-fontBold hw-blue">Categories</div>
            <div className="hw-book--filterSlide">
              <div
                className={`hw-book--filterSlideItem ${!selectedCategory?.catId || selectedCategory?.catId === "all" ? "active" : ""
                  }`}
                onClick={() => {
                  setSelectedCategory({});
                }}
              >
                All
              </div>
              {loading ? (
                <Skeleton
                  inline
                  height="40px"
                  width={"100%"}
                  count={5}

                />
              ) : (
                  Array?.isArray(data) && data?.length > 0 ?
                  data?.map?.((d) => {
                      return (
                          <div
                              key={d?.catId}
                              className={`hw-book--filterSlideItem ${String(selectedCategory?.catId) === String(d?.catId) ? "active" : ""
                              }`}
                              onClick={() => {
                                  setSelectedCategory(d);
                              }}
                          >

                              {d?.catName}
                          </div>
                      );
                  }) : null
              )}
            </div>
          </div>
                 </div>


                <div className="hw-search--flightFilter__widget">
                  {/* <div class="mb-2 hw-fontBold hw-blue">Price</div> */}
                  <div className={`hw-price--dropdown active`}>

                    <div
                      className="mb-2 hw-fontBold hw-blue"
                    >
                      {/* {sortBy?.title} */}
                      Sort by
                    </div>

                      <div className="hw-book--filterSlide">
                        {sortOptions.map((d) => {
                          return (
                            <div className={`hw-book--filterSlideItem ${sortBy?.title === d?.title ? "active" : ""}`}
                              onClick={() => {
                                setSortBy(d);
                                // setSortFilter(false);
                              }}
                            >
                              {d.title}
                            </div>
                          );
                        })}
                      </div>

                  </div>
              </div>
            </div>
          </div>
        </aside>
        )}
        <div className="hw-search--flightFilterResult">
          <div className="hw-book--ticketSection">

          <div className="hw-book--filterResult">
            <div className="">
              {listLoading ? (
                <>
                  <ExcursionSkeletonCard />
                </>
              ) : (
                <div className="row">
                  {list?.map((item) => {
                    return (
                      <div
                        className="col-sm-6 col-xl-4"
                        onClick={() => {
                          goToDetails(item);
                        }}
                      >
                        <div className="hw-book--filterResultGrid">
                          <a className="whole-link" href="#"></a>
                          <div className="image-box">
                            <img
                              src={item?.excursionThumbnail}
                              alt={item?.excursionTitle}
                              width="300"
                            />
                          </div>
                          <div className="content-box">
                            <div className="hw-text14">
                              {item?.excursionCatagories
                                ?.map((cat) => {
                                  return cat?.taxonomyName;
                                })
                                ?.join(" | ")}
                            </div>
                            <div className="hw-ticket--title">
                              {item?.excursionTitle}
                            </div>
                            <div className="content-box--inner">
                                <div className="price">
                                  <small>From</small>
                                    {formatePriceFn(agentActiveCurrency , formatPrice(item?.excursionPrice?.adultPrice,false,false,true), displayPrice)}
                                </div>
                                {item?.instantConfirmation === "Yes" || true ? (
                                  <div className="tick-list">
                                    Instant Confirmation
                                  </div>
                                ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {!listLoading && list?.length <= 0 ? (
                <div className={" text-center hw-fontWeight--500"} style={{ padding: "56px 24px", background: "#fff", borderRadius: 8, minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                  <svg width="210" height="140" viewBox="0 0 210 140" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "block" }} aria-hidden="true">
                    <g stroke="#b4bac6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
                      <path d="M150 34C145 34 145 25 151 25C151 20 160 18 163 23C167 17 178 20 176 27C182 27 182 34 177 34Z" />
                      <path d="M102 110C102 110 84 84 84 62a18 18 0 1 1 36 0C120 84 102 110 102 110Z" />
                      <circle cx="102" cy="61" r="7" />
                      <path d="M34 112C54 112 62 106 88 108" strokeDasharray="1 7" />
                      <circle cx="34" cy="112" r="3" fill="#b4bac6" stroke="none" />
                      <path d="M22 112h24" />
                      <path d="M118 112h28" />
                      <path d="M152 112h26" />
                    </g>
                  </svg>
                  <h3 className="hw-black900" style={{ marginBottom: 12 }}>No results found</h3>
                  <p style={{ maxWidth: 460, marginLeft: "auto", marginRight: "auto", lineHeight: 1.6 }}>
                    No records found with selected category, please check
                    another categories.
                  </p>
                  <button type="button" className="hw-btn hw-btn--primary" style={{ marginTop: 20, padding: "10px 28px" }} onClick={() => navigate(-1)}>
                    Go Back
                  </button>
                </div>
              ) : null}
              {showLoadMore && list?.length > 0 ? (

                <div className="ml-auto col-md-4 mr-auto mt-6">
                  <div className="load-more d-flex justify-center">
                    {" "}
                    <button
                      onClick={() => {
                        setPage(page + 1);
                      }}
                      className="w-100 hw-btn hw-btn--mdSize hw-btn--primaryOutline"
                    >
                      Load More
                    </button>
                  </div>
                </div>

              ) : null}
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ExcursionList;
